import React, { useEffect } from "react";
import SectionHotBannerSlider from "./SectionHotBannerSlider";
import { useSelector } from "react-redux";
import {
  getHomePageBanner,
  getHomePageNewestAudioStory,
  getHomePageNewestAudioBook,
  getHomePageNewestAudioPodcast,
  getHomePageNewestRadio,
} from "redux/slices/homepage";
import { useDispatch } from "redux/store";
import SectionListPodCastItem from "_components/SectionListPodCastItem/SectionListPodCastItem";
import SectionListAudioItem from "_components/SectionListAudioItem/SectionListAudioItem";
import { APP_NAME } from "../../config";

const PageHome = () => {
  const dispatch = useDispatch();
  const {
    hot_banners,
    newest_audio_podcast,
    newest_audio_story,
    newest_audio_radio,
    newest_audio_book,
  } = useSelector((state: any) => state.homepage);
  useEffect(() => {
    dispatch(getHomePageBanner());
    dispatch(getHomePageNewestAudioStory());
    dispatch(getHomePageNewestAudioBook());
    dispatch(getHomePageNewestAudioPodcast());
    dispatch(getHomePageNewestRadio());
    document.title = APP_NAME;
  }, []);
  return (
    <div className="nc-PageHome relative">
      <div className="container relative">
        <SectionHotBannerSlider
          className="pt-10 pb-16 md:py-16 lg:pb-28 lg:pt-20"
          posts={hot_banners}
        />
        {/*<SectionAds />*/}
      </div>
      <div className="container ">
        {newest_audio_podcast.length > 0 && <SectionListPodCastItem
          heading="Podcast mới cập nhật"
          className="py-10 lg:py-10"
          books={newest_audio_podcast}
        />}
        {newest_audio_story.length > 0 && <SectionListAudioItem
          heading="Truyện mới cập nhật"
          className="py-10 lg:py-10"
          books={newest_audio_story}
        />}
        {newest_audio_radio.length > 0 && <SectionListAudioItem
          heading="Radio mới cập nhật"
          className="py-10 lg:py-10"
          books={newest_audio_radio}
        />}
        {newest_audio_book.length > 0 && <SectionListAudioItem
          heading="AudioBook mới cập nhật"
          className="py-10 lg:py-10"
          books={newest_audio_book}
        />}

      </div>
    </div>
  );
};
;

export default PageHome;
